import React from 'react';
import { FadeIn } from './FadeIn';
import { Check, X } from 'lucide-react';
export function WhoIsItFor() {
  const forWho = ['Emprendedores que sienten que han llegado a un techo de cristal por agotamiento.', 'Buscadores de libertad financiera que no quieren vender su alma al sistema corporativo.', 'Personas que ya generan dinero pero se sienten vacías, ansiosas o físicamente deterioradas.', 'Inversionistas que quieren dominar su psicología para no perder la calma en mercados volátiles.'];
  const notForWho = ["Gente que busca 'dinero fácil' de la noche a la mañana sin compromiso personal.", 'Quienes no están dispuestos a cambiar sus hábitos diarios de salud y mentalidad.', 'Personas que creen que la libertad financiera es solo un número en una pantalla.'];
  return <section className="bg-brand-dark text-brand-cream py-24 px-6" data-id="element-201">
      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12" data-id="element-202">
        <FadeIn data-id="element-203">
          <div className="bg-brand-green/30 p-8 md:p-12 rounded-sm border border-brand-gold/20 h-full" data-id="element-204">
            <h2 className="text-2xl md:text-3xl font-bold mb-8 text-brand-gold" data-id="element-205">
              Este libro ES para ti si...
            </h2>
            <ul className="space-y-6" data-id="element-206">
              {forWho.map((item, index) => <li key={index} className="flex gap-4 items-start" data-id="element-207">
                  <div className="bg-brand-gold/20 p-1 rounded-full flex-shrink-0 mt-1" data-id="element-208">
                    <Check className="w-5 h-5 text-brand-gold" data-id="element-209" />
                  </div>
                  <span className="font-light text-brand-cream/90 leading-relaxed" data-id="element-210">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-211">
          <div className="bg-black/20 p-8 md:p-12 rounded-sm border border-red-900/30 h-full" data-id="element-212">
            <h2 className="text-2xl md:text-3xl font-bold mb-8 text-red-400/80" data-id="element-213">
              Este libro NO es para ti si...
            </h2>
            <ul className="space-y-6" data-id="element-214">
              {notForWho.map((item, index) => <li key={index} className="flex gap-4 items-start" data-id="element-215">
                  <div className="bg-red-900/20 p-1 rounded-full flex-shrink-0 mt-1" data-id="element-216">
                    <X className="w-5 h-5 text-red-400/80" data-id="element-217" />
                  </div>
                  <span className="font-light text-brand-cream/70 leading-relaxed" data-id="element-218">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </FadeIn>
      </div>
    </section>;
}